import './virtualFocus.css';
export var virtualFocus = {neutral:'_9mvxlq0-3-8-0',primary:'_9mvxlq1-3-8-0'};